(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.custom-banner__toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const descriptionContent = this.previousElementSibling;
        const expandText = this.querySelector('.expand-text');
        const collapseText = this.querySelector('.collapse-text');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        const fullText = descriptionContent.dataset.fullText;
        const truncatedText = descriptionContent.dataset.truncatedText;

        if (isExpanded) {
          // Collapse
          descriptionContent.innerHTML = truncatedText;
          expandText.style.display = 'inline';
          collapseText.style.display = 'none';
          this.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          descriptionContent.innerHTML = fullText;
          expandText.style.display = 'none';
          collapseText.style.display = 'inline';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
